<template>
  <div class="animated wow fadeIn">
    <div class="spacer"></div>
    <KontaktComponent />
    <div class="spacer"></div>
    <Prices />
    <div class="spacer"></div>
    <div class="spacer"></div>
    <div class="spacer"></div>
  </div>
</template>

<script>
import KontaktComponent from '@/components/KontaktComponent'
import Prices from '@/components/Prices'
import sku from '@/sku'

export default {
  components: {
    Prices,
    KontaktComponent
  },
  mounted() {
    sku.animateAutoWidthAndHeight('.blue-box')
  }
}
</script>
